const message = observation => {
  if (observation !== null) {
    return observation
  }

  return 'Nenhuma observação foi adicionada.'
}

export default message
